import { UserAddress } from '../../clients/quipli-service/user/user';
import { components } from 'react-select';
import { Typography } from '../typography/typography';
import { AsyncSelectForm } from '../select-form/select-form';
import { useCallback } from 'react';
import { debounce } from 'lodash';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { formatAddress } from '../../util/util';
import Icon from '../icons/icon';

export const UserAddressSearch = ({
  userId,
  selectedAddress,
  onSelectAddress,
}: {
  userId?: number;
  selectedAddress?: UserAddress;
  onSelectAddress: (address?: UserAddress) => void;
}) => {
  const { searchAddresses } = useAPI();

  const loadAddresses = useCallback(
    debounce(function (value: string, callback) {
      if (!userId) return;

      searchAddresses({ userId, allowDeleted: false, keyword: value, pageNumber: 1, pageSize: 10 })
        .then((response) => callback(response.items))
        .catch(() => console.log('Failed to search addresses'));
    }, 500),
    [userId],
  );

  return (
    <AsyncSelectForm
      key={`user-address-search-${userId}`}
      cacheOptions
      defaultOptions
      className="w-full break-all"
      loadOptions={loadAddresses}
      value={selectedAddress}
      getOptionValue={(address) => address?.id.toString()}
      onChange={(address) => onSelectAddress(address || undefined)}
      loadingMessage={() => 'Loading...'}
      noOptionsMessage={() => 'No addresses found'}
      isClearable={true}
      menuPlacement="auto"
      components={{
        SingleValue: ({ ...props }) => (
          <components.SingleValue {...props}>
            <Typography type="text-sm">
              <span className="font-semibold capitalize">{props.data.type}: </span>
              {formatAddress(props.data)}
            </Typography>
          </components.SingleValue>
        ),
        Option: ({ ...props }) => (
          <components.Option {...props}>
            <div className="flex items-center gap-[6px] justify-between">
              <div className="flex flex-col">
                <Typography type="text-sm" weight="medium" className="capitalize flex items-center gap-2">
                  {props.data.type}
                  <Icon icon={props.data.type == 'billing' ? 'CreditCardCheck' : 'Delivery'} />
                </Typography>
                <Typography type="text-sm">{formatAddress(props.data)}</Typography>
              </div>

              {props.isSelected && <Icon icon="Check" stroke="var(--quipli-black-800)" />}
            </div>
          </components.Option>
        ),
      }}
    />
  );
};
